import React from 'react'

import Message from './Message'
import { COLORS } from '@btime/constants'
import { useSessionPermission } from '@btime/react-session'

const ExpiredContractMessage = () => {
  const shouldShowExpiredContractWarning = useSessionPermission('showExpiredContractWarning')

  return shouldShowExpiredContractWarning ? (
    <Message
      title="**🚨 Seu contrato expirou!** Clique [**aqui**](mailto:financeiro@btime.com.br) e entre em contato conosco o quanto antes para evitar o bloqueio do serviço. ⏳"
      useMarkdown={true}
      color={COLORS.dark3}
      bgColor={COLORS.lightYellow}
    />
  ) : (
    <></>
  )
}

export default ExpiredContractMessage
